import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import { merge } from 'lodash';

import ChartService from './ChartService';

export default class ChartDonutService extends ChartService {

  buildChartData(visualization, isEditMode) {

    const options = {

      series: [
        {
          data: visualization.data.map((item, ind) => {
            const defaultColor = item.color || 'rgb(113,205,242)';
            const uncheckedColor = 'rgb(216,216,216)';

            const color = isEditMode && item.unchecked ? uncheckedColor : defaultColor;
            return {
              data: item,
              dataIndex: ind,
              ...item,
              defaultColor,
              itemStyle: {
                normal: { color },
                emphasis: { color, opacity: 1 },
              }
            };
          }).reverse(),
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 2,
          },
          label: {
            color: '#000',
            formatter(params) {
              return `${params.name}\n${params.data.formattedValue || params.data.value}\n(${params.percent}%)`;
            },
            lineHeight: 14,
          },
          labelLine: {
            lineStyle: {
              color: '#000',
            },
          },
          radius: ['50%', '80%'],
          type: 'pie',
        },
      ],

      tooltip: {
        formatter(params) {
          return `<b>${params.name}</b>: ${params.data.formattedValue || params.data.value} (${params.percent}%)`;
        },
      },

    };

    return merge(this.defaultChartOptions, options);
  }

}
